import TeamHeaderTitlePresenter from "./TeamHeaderTitlePresenter";

export const TeamHeaderTitle = TeamHeaderTitlePresenter;

export default TeamHeaderTitle